import { of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { OrdersChart, OrdersChartData } from '../data/orders-chart';
import { DashboardChartData, DashboardChartSummary } from '../data/dashboard-chart';
import { ProfitChart, ProfitChartData } from '../data/profit-chart';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Injectable()
export class DashboardChartService extends DashboardChartData {

  private summary = [
    {
      title: this.translate.instant(marker('total_value')),
      value: 3654,
    },
    {
      title: this.translate.instant(marker('total_count')),
      value: 946,
    }
  ];

  constructor(private ordersChartService: OrdersChartData,
              private profitChartService: ProfitChartData,
              private translate: TranslateService
              ) {
    super();
  }

  getDashboardChartSummary(): Observable<DashboardChartSummary[]> {
    return observableOf(this.summary);
  }

  getOrdersChartData(period: string): Observable<OrdersChart> {
    return observableOf(this.ordersChartService.getOrdersChartData(period));
  }

  getProfitChartData(period: string): Observable<ProfitChart> {
    return observableOf(this.profitChartService.getProfitChartData(period));
  }
}
